import { useEffect, useState, useRef } from 'react';

let options = {
  rootMargin: '0px',
  threshold: 0.5
}

const useFetchHelper = ({ ref }) => {
  const [canFetch, setCanFetch] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        if (entry.isIntersecting) {
          setCanFetch(true);
        }
      }
    }, options);

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);

  useEffect(() => () => {
    mounted.current = false;
  }, []);

  return { canFetch };
};

export default useFetchHelper;
